import { useEffect, useState, useCallback } from 'react';
import { partesVbApi } from '../lib/api';
import { useAuth } from '../lib/auth';

/**
 * Polling del conteo de partes diarios pendientes de VB para el supervisor logueado.
 * Solo dispara fetch si el usuario podría ser supervisor (tiene PIN configurado o es admin/gerencia).
 * Refresca cada 60s y al volver a foco de la pestaña.
 */
export function useVBPendingCount() {
  const { user } = useAuth();
  const [count, setCount] = useState(0);

  const fetchCount = useCallback(async () => {
    if (!user) return;
    try {
      const res = await partesVbApi.misPendientes();
      setCount((res.data?.items || []).length);
    } catch {
      // Si el endpoint falla (ej: usuario sin PIN/no supervisor), simplemente no mostramos badge.
      setCount(0);
    }
  }, [user]);

  useEffect(() => {
    if (!user) return;
    fetchCount();
    const interval = setInterval(fetchCount, 60000);
    const onFocus = () => fetchCount();
    window.addEventListener('focus', onFocus);
    return () => {
      clearInterval(interval);
      window.removeEventListener('focus', onFocus);
    };
  }, [user, fetchCount]);

  return count;
}
